define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var AcrobitsAccountModel = /** @class */ (function () {
        function AcrobitsAccountModel(data) {
            this.Id = ko.observable();
            this.CustomerId = ko.observable();
            this.title = ko.observable();
            this.username = ko.observable();
            this.password = ko.observable();
            this.userDisplayName = ko.observable();
            this.authUsername = ko.observable();
            this.host = ko.observable("");
            this.transport = ko.observable("");
            this.expires = ko.observable(600);
            this.allowMessage = ko.observable(0);
            this.voiceMailNumber = ko.observable("");
            this.subscribeForVoicemail = ko.observable(0);
            this.codecOrder = ko.observable("103,9,0,8,18,102,3");
            this.codecOrder3G = ko.observable("18,103,102,3,9,0,8");
            this.extProvUrl = ko.observable("");
            this.extProvInterval = ko.observable(0);
            this.proxy = ko.observable("");
            this.outboundProxy_host = ko.observable("");
            this.outboundProxy_transport = ko.observable("");
            this.outboundProxy_enabled = ko.observable();
            this.tryingTone = ko.observable("");
            this.ringingTone = ko.observable("");
            this.endCallTone = ko.observable("");
            this.busyTone = ko.observable("");
            this.callWaitingTone = ko.observable("");
            this.ignoreRemoteUserDomain = ko.observable(0);
            this.minNumberLengthToIgnoreRemoteUserDomain = ko.observable(3);
            this.rewritingXml = ko.observable('');
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, AcrobitsAccountModel.Mapping, self);
            }
        }
        AcrobitsAccountModel.Mapping = {
            include: [
                "tryingTone", "ringingTone", "endCallTone", "busyTone", "callWaitingTone", "proxy", "outboundProxy_host",
                "outboundProxy_transport", "outboundProxy_enabled", "ignoreRemoteUserDomain", "minNumberLengthToIgnoreRemoteUserDomain", "rewritingXml"
            ],
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new AcrobitsAccountModel(options.data);
            }
        };
        return AcrobitsAccountModel;
    }());
    return AcrobitsAccountModel;
});
//# sourceMappingURL=AcrobitsAccountModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/AcrobitsAccountModel.js
// module id = 182
// module chunks = 2